<template>
    <div>
        <v-card flat>
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong>
                        Print Receipt
                    </strong>
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-btn v-if="learner_receipt_data != null" class="ma-2 no-display" id="wv_btn" tile outlined color="warning" @click="print()"> <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
            <v-row>
                <v-col cols="12" sm="6" md="6" class="m-0 p-0"> </v-col>
                <v-col cols="12" sm="6" md="6" class="m-0 p-0">
                    <v-card>
                        <v-simple-table dense class="elevation-1 table-container">
                            <template v-slot:default>
                                <thead>
                                    <tr v-bind="org_basic_data!=''">
                                        <td colspan="3" v-if="org_basic_data.trust_logo">
                                            <v-row dense justify="center">
                                                <v-col cols="12" md="2" sm="2">
                                                    <center><img :src="org_basic_data.trust_logo" width="150%" alt="logo" /></center>
                                                </v-col>
                                                <v-col cols="12" md="10" sm="10">
                                                    <center>
                                                        <tr v-if="org_basic_data.trust_name">
                                                            <strong>{{org_basic_data.trust_name}}</strong>
                                                        </tr>
                                                        <tr v-if="org_basic_data.school_name">
                                                            <strong>{{org_basic_data.school_name}} </strong>
                                                        </tr>
                                                        <tr v-if="org_basic_data.address">
                                                            {{org_basic_data.address}}
                                                        </tr>
                                                        <tr v-if="org_basic_data.phone">
                                                            Phone : {{org_basic_data.phone}}
                                                        </tr>
                                                        <tr v-if="org_basic_data.email">
                                                            Email : {{org_basic_data.email}}
                                                        </tr>
                                                        <tr v-if="org_basic_data.website">
                                                            Website : {{org_basic_data.website}}
                                                        </tr>
                                                    </center>
                                                </v-col>
                                            </v-row>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left" colspan="3">
                                            <v-row dense>
                                                <v-col cols="12" sm="6" md="6">
                                                    <tr class="text-left">
                                                        <strong> Receipt No. : {{learner_receipt_data.receipt_no}} </strong>
                                                    </tr>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="6">
                                                    <tr>
                                                        <span style="position: absolute; right: 50px;"> <strong> Receipt Date : {{learner_receipt_data.receipt_date}} </strong> </span>
                                                    </tr>
                                                </v-col>
                                            </v-row>

                                            <tr class="text-left">
                                                <strong> Reg No. : {{learner_receipt_data.registration_number}} </strong>
                                            </tr>
                                            <tr class="text-left">
                                                <strong> Student Name : {{learner_receipt_data.name}} </strong>
                                            </tr>
                                            <tr class="text-left">
                                                <strong> Class - Section : {{learner_receipt_data.standard}} {{learner_receipt_data.division}}</strong>
                                            </tr>
                                        </td>
                                    </tr>
                                   
                                    <tr>
                                        <td colspan="1"><strong>Particulars of Fee</strong></td>
                                        <td><strong> Fee Amount (Rs.)</strong></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td colspan="1">
                                         Bonafide Fee
                                        </td>
                                        <td>{{learner_receipt_data.amount}}</td>
                                    </tr>
                                </tbody>
                                <tr>
                                    <td colspan="3">
                                        <tr class="text-left">
                                            <strong> Total Receipt Amount :</strong>
                                            Rs. {{learner_receipt_data.amount}}.00
                                        </tr>
                                        <tr class="text-left">
                                            <strong> Amount In Words :</strong>
                                            {{ learner_receipt_data.amount_in_words }}
                                        </tr>
                                        <tr class="text-left">
                                            <strong> Payment Mode : </strong>
                                            {{learner_receipt_data.paymentmode}}
                                            
                                        </tr>
                                       
                                        
                                        <tr v-if="learner_receipt_data.paymentmode!='Cash'" class="text-left">
                                            <strong> Bank Name:</strong>
                                            {{ learner_receipt_data.bank }}
                                        </tr>
                                       
                                        <tr>
                                            <v-row>
                                                <v-col cols="12" sm="5" md="5"> </v-col>
                                                <v-col cols="12" sm="7" md="7">
                                                    <span style="position: absolute; right: 50px;"><strong>{{org_basic_data.school_name}} </strong></span>
                                                </v-col>
                                            </v-row>
                                        </tr>
                                        <tr>
                                            <br />
                                            <br />
                                            <span style="position: absolute; bottom: 40px; right: 120px;"><strong>Signature</strong></span>
                                        </tr>
                                        <tr class="text-left">
                                            * Fees once paid is not refundable/ non-transferable.
                                            <br />
                                            * Cheques/ECS/ Online payment are subject to realization.
                                            <br />
                                            * Bouncing of Cheques/ ECS will fetch penalty.
                                            <br />
                                        </tr>
                                    </td>
                                </tr>
                            </template>
                        </v-simple-table>
                    </v-card>
                </v-col>
            </v-row>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                overlay: false,
                learner_receipt_data: null,
                radios: null,
                receipt_no: null,
                ay: null,
                org_basic_data: [],
            };
        },
        watch: {
            receipt_no() {
                this.getData();
            },

            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },
        created() {
            this.receipt_no = JSON.parse(this.$session.get("receipt_no"));
            this.ay = JSON.parse(this.$session.get("ay"));
        },
        mounted() {
            this.getData();
        },
        methods: {
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            convert(number) {
                var converter = require("number-to-words");
                const string = converter.toWords(number);
                const string1 = string.charAt(0).toUpperCase() + string.slice(1);
                return string1;
            },
            getData() {
                this.overlay = true;
                this.learner_receipt_data = null;
                const formData = {
                    receipt_no: this.receipt_no,
                    ay: this.ay,
                };
                axios
                    .post("/Certificate/getReceipt", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.learner_receipt_data = res.data.receipt_data;
                            this.org_basic_data = res.data.org_basic_data;
                            this.overlay = false;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            this.overlay = false;
                            return;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        //close loader
                        this.overlay = false;
                    });
            },
        },
    };
</script>
<style scoped>
    @media all and (max-width: 900px) {
        .padding-bot {
            padding: 8px;
        }
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }

    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
    }
    @media print {
        header,
        footer,
        nav,
        date {
            display: none !important;
        }
        table,
        td,
        tr {
            break-inside: avoid-page;
        }
        img {
            width: 180% !important;
        }
        body,
        tr,
        th,
        td {
            font-size: xx-large !important;
            /* font-weight: bold !important; */
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        @page {
            size: A4;
            margin-top: none;
            padding-top: none;
            size: 25in 20in;
        }
        table,
        td,
        tr,
        th {
            text-align: center !important;
            margin-top: none;
            padding: 1rem !important;
            font-size: xx-large !important;
            /* font-weight: bold !important; */
            border-bottom: 1px solid black;
            border: 1px solid black;
        }
    }
    .table-container {
        overflow-x: hidden;
        overflow: hidden;
    }
    .text {
        color: red !important;
        font-size: bold !important;
    }
</style>
